import { api } from "@/api";

class API {
  static getCourt(payload) {
    return api.get(`/v1/judiciario/tribunais${payload}`);
  }
  static getRegionCourt(value) {
    return api.get(
      `/v1/judiciario/tribunais/${value.id}/unidades${value.payload}`
    );
  }
  static getCurrentCourt(payload) {
    return api.get(`/v1/judiciario/tribunais/${payload}`);
  }
  static putCourt(value) {
    return api.put(`/v1/judiciario/tribunais/${value.id}`, value.payload);
  }
  static postCourt(payload) {
    return api.post("/v1/judiciario/tribunais", payload);
  }
  static getSegment() {
    return api.get("v1/judiciario/suggest");
  }
  static getCurrentRegionCourt(payload) {
    return api.get(
      `/v1/judiciario/tribunais/${payload.tribunal}/unidades/${payload.vara}`
    );
  }
  static putRegionCourt(value) {
    return api.put(
      `/v1/judiciario/tribunais/${value.tribunal}/unidades/${value.vara}`,
      value.payload
    );
  }
  static postRegionCourt(value) {
    return api.post(
      `/v1/judiciario/tribunais/${value.tribunal}/unidades`,
      value.payload
    );
  }
}

export default API;
